/* eslint-disable import/named */
import { call, put, takeEvery } from "redux-saga/effects";
import * as types from "../constants";

import * as services from "./service";
import * as Notification from "./notification-saga";

export function* getListBlog(actions) {
  const response = yield call(services.getListBlogServer, actions.number);
  if (response) {
    yield put({
      type: types.GET_LIST_BLOG_RESULT,
      payload: response,
    });
  } else {
    console.log(response);
  }
}

export function* getListNotificationSaga() {
  const response = yield call(Notification.getListNotificationService);
  if (response) {
    yield put({
      type: types.GET_LIST_NOTIFICATION_RESULT,
      payload: response,
    });
  } else {
    console.log(response);
  }
}

export function* getNotificationDetailSaga(data) {
  const response = yield call(
    Notification.getNotificationDetailService,
    data.id,
  );
  if (response) {
    yield put({
      type: types.GET_NOTIFICATION_DETAIL_RESULT,
      payload: response,
    });
  } else {
    console.log(response);
  }
}

export function* updateNotificationSaga(data) {
  const response = yield call(Notification.updateNotificationService, data.id);
  if (response) {
    yield put({
      type: types.GET_LIST_NOTIFICATION,
    });
  } else {
    console.log(response);
  }
}

export function* changeAppStatusSaga(data) {
  const response = yield call(services.changeAppStatusServer, data.status);
  if (response && response.success) {
    yield put({
      type: types.CHANGE_APP_STATUS_RESULT,
      res: { result: 1, status: data.status },
    });
  } else {
    yield put({
      type: types.CHANGE_APP_STATUS_RESULT,
      res: { result: 2, status: !data.status },
    });
  }
}

export function* getSettingDataSaga() {
  const response = yield call(services.getSettingDataServer);
  if (response) {
    yield put({
      type: types.GET_SETTINGS_RESULT,
      res: response,
    });
  }
}

export function* getShopInfoSaga({ shop_domain }) {
  const response = yield call(services.getShopInfoService, shop_domain);
  if (
    response &&
    response.myshopify_domain &&
    response.myshopify_domain.includes(".myshopify.com")
  ) {
    window.fcWidget.user.setProperties({
      firstName: response.name,
      shopOwner: response.shop_owner,
      email: response.email,
      phone: response.phone,
      shop: response.myshopify_domain,
    });
    const style = document.createElement("style");
    style.innerHTML = "#fc_frame{display: unset!important;}";
    document.body.appendChild(style);
  }
}

function* sagaActions() {
  yield takeEvery(types.GET_LIST_BLOG, getListBlog);
  yield takeEvery(types.GET_LIST_NOTIFICATION, getListNotificationSaga);
  yield takeEvery(types.UPDATE_NOTIFICATION, updateNotificationSaga);
  yield takeEvery(types.CHANGE_APP_STATUS, changeAppStatusSaga);
  yield takeEvery(types.GET_SETTINGS, getSettingDataSaga);
  yield takeEvery(types.GET_SHOP_INFO, getShopInfoSaga);
}

export default sagaActions;
